import { format } from 'date-fns';
import { getTimezoneOffset, toZonedTime } from 'date-fns-tz';

export const TimeZoneUtils = {
  detectUserTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      console.warn('Unable to detect timezone:', error);

      return 'UTC';
    }
  },
  detectUserTimezoneAndDisplayDate(
    dateString: Date | string,
    dateFormat: string,
  ) {
    if (!dateString) {
      return;
    }

    const userTimezone = this.detectUserTimezone();

    const zonedDate = toZonedTime(dateString, userTimezone);

    return format(zonedDate, dateFormat);
  },
  getUtcOffsetHours() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const offsetInMilliseconds = getTimezoneOffset(userTimezone);
    const offsetInHours = offsetInMilliseconds / (1000 * 60 * 60);

    return offsetInHours;
  },
  calculatePromoTimeLeft(expirationDate: string | Date): number {
    const currentTime = new Date();
    const expDate = new Date(expirationDate);

    const year = expDate.getUTCFullYear();
    const month = expDate.getUTCMonth();
    const day = expDate.getUTCDate();

    const endOfDayInUserTz = new Date(year, month, day, 23, 59, 59, 999);

    const timeLeft = endOfDayInUserTz.getTime() - currentTime.getTime();

    return Math.max(0, timeLeft / 1000);
  },
};
